import type { SalesOpenSchedule } from "@/canvas/features/FormV2/blocks/campaign-details/SalesOpeningChip/useSalesOpenSchedule";

export type AuctionDrawerBidState =
  | { kind: "closed" }
  | { kind: "salesScheduled"; salesOpenDate: Date }
  | { kind: "open" };

export interface ResolveAuctionDrawerBidStateInput {
  ticketingIsClosed: boolean;
  isRateClosed: boolean;
  salesSchedule: SalesOpenSchedule;
}

export const resolveAuctionDrawerBidState = ({
  ticketingIsClosed,
  isRateClosed,
  salesSchedule,
}: ResolveAuctionDrawerBidStateInput): AuctionDrawerBidState => {
  if (ticketingIsClosed || isRateClosed) {
    return { kind: "closed" };
  }
  if (salesSchedule.isSalesScheduled && salesSchedule.salesOpenDate) {
    return { kind: "salesScheduled", salesOpenDate: salesSchedule.salesOpenDate };
  }
  return { kind: "open" };
};
